import MaleIcon from "@/assets/images/man.png";
import FemaleIcon from "@/assets/images/woman.png";

import MaleThin from "@/assets/icons/male_thin.svg";
import MaleTrained from "@/assets/icons/male_trained.svg";
import MaleCurvy from "@/assets/icons/male_curvy.svg";

import FemaleThin from "@/assets/icons/female_thin.svg";
import FemaleTrained from "@/assets/icons/female_trained.svg";
import FemaleCurvy from "@/assets/icons/female_curvy.svg";

export const getManualIcon = (
  stepId: string,
  value: string,
  gender: string = "male",
) => {
  if (stepId === "gender") {
    if (value === "male") return MaleIcon;
    if (value === "female") return FemaleIcon;
  }

  if (stepId === "body_type") {
    const key = `${gender}_${value}` as const;

    const map: Record<string, string> = {
      male_thin: MaleThin,
      male_trained: MaleTrained,
      male_curvy: MaleCurvy,
      female_thin: FemaleThin,
      female_trained: FemaleTrained,
      female_curvy: FemaleCurvy,
    };

    return map[key] ?? null;
  }

  return null;
};
